import { Component, DestroyRef, inject, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { QlikService } from "../felles/services/qlik.service";
import { AccordionComponent } from "@husbanken/designsystem-angular-core";
import { AccordionElementComponent, CalloutComponent } from "@husbanken/designsystem-angular-core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { DownloaddatasettComponent } from "../felles/components/downloaddata/downloaddatasett.component";

@Component({
  selector: "stat-datasett",
  templateUrl: "./datasettcontainer.component.html",
  imports: [AccordionComponent, AccordionElementComponent, CalloutComponent, DownloaddatasettComponent],
})
export class DatasettcontainerComponent implements OnInit {
  kpi = null;

  qlikService = inject(QlikService);
  destroyRef = inject(DestroyRef);
  titleService = inject(Title);

  constructor() {
    this.qlikService.resetFilter();
    this.qlikService.setFylkeFilter();
  }

  ngOnInit() {
    this.titleService.setTitle("Statistikk - Åpne data fra Husbanken");
    this.qlikService
      .getKpi("DatalastTidspunkt")
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => (this.kpi = result));
  }

  datasets = [
    {
      title: "Tilgjengelige datasett",
      omDataGrunnlaget:
        "Datasettene er tilgjengeliggjort for hovedleddene i saksbehandlingsprosessen: søknad, tilsagn og utbetaling. Kommaseparert fil i CSV format benytter tegnsett UTF-8.",
      rader: [
        {
          radTittel: "Grunnlån (historisk ordning)",
          linker: [
            {
              navn: "Søknad",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Søknad",
              virkemiddel: "GRUNNLÅN",
            },
            {
              navn: "Tilsagn",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Tilsagn",
              virkemiddel: "GRUNNLÅN",
            },
            {
              navn: "Utbetaling",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Utbetaling",
              virkemiddel: "GRUNNLÅN",
            },
          ],
        },

        {
          radTittel: "Lån til boligkvalitet",
          linker: [
            {
              navn: "Søknad",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Søknad",
              virkemiddel: "LÅN_HB",
            },
            {
              navn: "Tilsagn",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Tilsagn",
              virkemiddel: "LÅN_HB",
            },
            {
              navn: "Utbetaling",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Utbetaling",
              virkemiddel: "LÅN_HB",
            },
          ],
        },

        {
          radTittel: "Lån til utleieboliger",
          linker: [
            {
              navn: "Søknad",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Søknad",
              virkemiddel: "LÅN_UTLEIE",
            },
            {
              navn: "Tilsagn",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Tilsagn",
              virkemiddel: "LÅN_UTLEIE",
            },
            {
              navn: "Utbetaling",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Utbetaling",
              virkemiddel: "LÅN_UTLEIE",
            },
          ],
        },
        {
          radTittel: "Lån til studentboliger",
          linker: [
            {
              navn: "Søknad",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Søknad",
              virkemiddel: "LÅN_STUDENT",
            },
            {
              navn: "Tilsagn",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Tilsagn",
              virkemiddel: "LÅN_STUDENT",
            },
            {
              navn: "Utbetaling",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Utbetaling",
              virkemiddel: "LÅN_STUDENT",
            },
          ],
        },
        {
          radTittel: "Lån til barnehager (Historisk ordning)",
          linker: [
            {
              navn: "Søknad",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Søknad",
              virkemiddel: "BARNEHAGELÅN",
            },
            {
              navn: "Tilsagn",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Tilsagn",
              virkemiddel: "BARNEHAGELÅN",
            },
            {
              navn: "Utbetaling",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Utbetaling",
              virkemiddel: "BARNEHAGELÅN",
            },
          ],
        },
        {
          radTittel: "Tilskudd til utleieboliger",
          linker: [
            {
              navn: "Søknad",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Søknad",
              virkemiddel: "TILSK_UTLEIE",
            },
            {
              navn: "Tilsagn",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Tilsagn",
              virkemiddel: "TILSK_UTLEIE",
            },
            {
              navn: "Utbetaling",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Utbetaling",
              virkemiddel: "TILSK_UTLEIE",
            },
          ],
        },
        {
          radTittel: "Tilskudd til tilstandsvurdering",
          linker: [
            {
              navn: "Søknad",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Søknad",
              virkemiddel: "TILSK_TILSTAND",
            },
            {
              navn: "Tilsagn",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Tilsagn",
              virkemiddel: "TILSK_TILSTAND",
            },
            {
              navn: "Utbetaling",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Utbetaling",
              virkemiddel: "TILSK_TILSTAND",
            },
          ],
        },
        {
          radTittel: "Tilskudd til boligsosiale tiltak",
          linker: [
            {
              navn: "Søknad",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Søknad",
              virkemiddel: "TILSK_BOLIGSOSIALT",
            },
            {
              navn: "Tilsagn",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Tilsagn",
              virkemiddel: "TILSK_BOLIGSOSIALT",
            },
            {
              navn: "Utbetaling",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Utbetaling",
              virkemiddel: "TILSK_BOLIGSOSIALT",
            },
          ],
        },
        {
          radTittel: "Tilskudd til heis",
          linker: [
            {
              navn: "Søknad",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Søknad",
              virkemiddel: "TILSK_HEIS",
            },
            {
              navn: "Tilsagn",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Tilsagn",
              virkemiddel: "TILSK_HEIS",
            },
            {
              navn: "Utbetaling",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Utbetaling",
              virkemiddel: "TILSK_HEIS",
            },
          ],
        },
        {
          radTittel: "Prosjekteringstilskudd",
          linker: [
            {
              navn: "Søknad",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Søknad",
              virkemiddel: "TILSK_PROSJEKTERING",
            },
            {
              navn: "Tilsagn",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Tilsagn",
              virkemiddel: "TILSK_PROSJEKTERING",
            },
            {
              navn: "Utbetaling",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Utbetaling",
              virkemiddel: "TILSK_PROSJEKTERING",
            },
          ],
        },
        {
          radTittel: "Områdeutvikling",
          linker: [
            {
              navn: "Søknad",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Søknad",
              virkemiddel: "TILSK_OMRÅDEUTV",
            },
            {
              navn: "Tilsagn",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Tilsagn",
              virkemiddel: "TILSK_OMRÅDEUTV",
            },
            {
              navn: "Utbetaling",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Utbetaling",
              virkemiddel: "TILSK_OMRÅDEUTV",
            },
          ],
        },
        {
          radTittel: "Bærekraftig bo- og byggkvalitet",
          linker: [
            {
              navn: "Søknad",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Søknad",
              virkemiddel: "TILSK_BÆREKRAFT",
            },
            {
              navn: "Tilsagn",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Tilsagn",
              virkemiddel: "TILSK_BÆREKRAFT",
            },
            {
              navn: "Utbetaling",
              objekt: "qv-datasett-lån-og-tilskudd",
              tilstand: "Utbetaling",
              virkemiddel: "TILSK_BÆREKRAFT",
            },
          ],
        },
        {
          radTittel: "Investeringstilskudd",
          linker: [
            {
              navn: "Søknad",
              objekt: "qv-datasett-investeringstilskudd",
              tilstand: "Søknad",
              virkemiddel: "INVTILSKUDD",
            },
            {
              navn: "Tilsagn",
              objekt: "qv-datasett-investeringstilskudd",
              tilstand: "Tilsagn",
              virkemiddel: "INVTILSKUDD",
            },
            {
              navn: "Utbetaling",
              objekt: "qv-datasett-investeringstilskudd",
              tilstand: "Utbetaling",
              virkemiddel: "INVTILSKUDD",
            },
          ],
        },
        {
          radTittel: "Energitilskudd",
          linker: [
            {
              navn: "Søknad",
              objekt: "qv-datasett-energitilskudd",
              tilstand: "Søknad",
              virkemiddel: "ENETILSKUDD",
            },
            {
              navn: "Tilsagn",
              objekt: "qv-datasett-energitilskudd",
              tilstand: "Tilsagn",
              virkemiddel: "ENETILSKUDD",
            },
            {
              navn: "Utbetaling",
              objekt: "qv-datasett-energitilskudd",
              tilstand: "Utbetaling",
              virkemiddel: "ENETILSKUDD",
            },
          ],
        },
      ],
    },
  ];
}
